<template>
    <!--
        Contract: the profile link renders only when the payload carries a
        server-computed `canView` (user view policy, hierarchy-aware) and an id.
        Payloads without canView deliberately degrade to plain text (fail
        closed) — any new feeder must supply it the way UserResource and
        TestRecordOverviewResource do.
    -->
    <Link v-if="info.canView && info.id" :href="$route('users.show', info.id)" @click.stop>
        <div class="text-truncate">{{ info.name }}</div>
        <small v-if="info.email" class="block truncate text-muted">{{ info.email }}</small>
    </Link>
    <div v-else>
        <div class="text-truncate">{{ info.name }}</div>
        <small v-if="info.email" class="block truncate text-muted">{{ info.email }}</small>
    </div>
</template>
<script setup>
defineProps(['info']);
</script>
